module.exports = __webpack_public_path__ + "img/info.3e096268.png";